import { z } from 'zod';

// Gateway Schema
export const gatewaySchema = z.object({
  eui: z
    .string()
    .min(1, 'EUI الزامی است')
    .regex(/^[0-9A-Fa-f]{16}$/, 'EUI باید 16 کاراکتر هگزادسیمال باشد'),
  name: z
    .string()
    .min(3, 'نام باید حداقل 3 کاراکتر باشد')
    .max(100, 'نام نمی‌تواند بیشتر از 100 کاراکتر باشد'),
});

// Gateway Update Schema (without EUI)
export const gatewayUpdateSchema = z.object({
  name: z
    .string()
    .min(3, 'نام باید حداقل 3 کاراکتر باشد')
    .max(100, 'نام نمی‌تواند بیشتر از 100 کاراکتر باشد'),
});
